import React, { createContext, useContext, useState } from "react";
import { useCart } from "./CartContext";
import { useDispatch } from "react-redux";
import { setCart } from "../Redux/CartSlice";
import { toast } from "react-toastify";

const LabCartContext = createContext();

export const LabCartProvider = ({ children }) => {
  const { cart, addToCart, removeFromCart } = useCart();
  const dispatch = useDispatch();

  const [pendingItem, setPendingItem] = useState(null);
  const [showReplacePopup, setShowReplacePopup] = useState(false);
  const [loading, setLoading] = useState(false);

  // ================= HANDLE ADD =================
  const handleAddItem = (item, currentLabId) => {
  const currentStoreId = Number(currentLabId);

  const cartStoreIds = cart
    .map((cartItem) => Number(cartItem.storeId))
    .filter((id) => !isNaN(id));

  const hasDifferentStore =
    cartStoreIds.length > 0 &&
    cartStoreIds.some((storeId) => storeId !== currentStoreId);

  const itemName = item.name || item.testName || "Item";

  if (hasDifferentStore) {
    setPendingItem({
      ...item,
      storeId: currentStoreId,
    });
    setShowReplacePopup(true);
  } else {
      addToCart({
      ...item,
      storeId: currentStoreId,
    });

      // ✅ Dynamic TOAST ADD
      toast.success(`${itemName} added to cart 🛒`);
  }
};

  // ================= HANDLE REMOVE =================
  const handleRemoveItem = (item) => {
    const itemName = item.name || item.testName || "Item";

    removeFromCart(item);

    // ✅ Dynamic TOAST REMOVE
    toast.info(`${itemName} removed from cart ❌`);
  };

  // ================= REPLACE CART =================
  const confirmReplaceCart = async () => {
    if (!pendingItem) return;

    setLoading(true);

    try {
      const cartId = localStorage.getItem("cartId");

      console.log("🔁 Replace started...");
      console.log("Cart ID:", cartId);

      // ✅ Step 1: Call DELETE CART API
      if (cartId && cartId !== "0") {
        const response = await fetch(
          "https://online-tech.in/api/MasterAPI/DeleteCart",
          {
            method: "POST",
            headers: {
              accept: "*/*",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              cardId: Number(cartId),
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Delete cart API failed");
        }

        await response.json();
      }

      // ✅ Step 2: Clear Redux
      dispatch(setCart([]));

      // ✅ Step 3: Clear localStorage
      localStorage.removeItem("cartId");

      // ✅ Step 4: Add new item
      await addToCart(pendingItem);

      const itemName =
        pendingItem.name || pendingItem.testName || "Item";

      toast.success(`${itemName} added after replacing cart ✅`);
    } catch (err) {
      console.error("❌ Replace error:", err);
      toast.error("Failed to replace cart ❌");
    }

    setLoading(false);
    setPendingItem(null);
    setShowReplacePopup(false);
  };

  // ================= CANCEL =================
  const cancelReplaceCart = () => {
    setPendingItem(null);
    setShowReplacePopup(false);
  };

  return (
    <LabCartContext.Provider
      value={{
        handleAddItem,
        handleRemoveItem,
        pendingItem,
        showReplacePopup,
        confirmReplaceCart,
        cancelReplaceCart,
        loading,
      }}
    >
      {children}
    </LabCartContext.Provider>
  );
};

export const useLabCart = () => useContext(LabCartContext);